import Vue from "vue";
import VueIntercom from "vue-intercom";

Vue.use(VueIntercom, {
  appId: "hshb1v0u",
});
